import AnimeCard from '@/components/base/AnimeCard';
import { animeList, latestAnimeIds } from '@/mocks/anime';

export default function LatestSection() {
  const latestAnime = latestAnimeIds
    .map((id) => animeList.find((a) => a.id === id))
    .filter(Boolean) as typeof animeList;

  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="latest-title">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 id="latest-title" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              最近更新
            </h2>
            <p className="text-sm text-foreground-500">每日同步更新最新剧集</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="hidden sm:inline text-xs text-accent-600 font-medium whitespace-nowrap">
              更新中
            </span>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latestAnime.slice(0, 8).map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>
      </div>
    </section>
  );
}